module.exports = __webpack_public_path__ + "static/webdesign.83718cac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/webdesign.jpg
// module id = 820
// module chunks = 19817326959855